import '@posthog/tailwind/tailwind.css'

// global.scss must load AFTER tailwind so our base styles win the cascade
import './global.scss'

/* Contains PostHog's main styling configurations */
